var map = {
	"./AI-generated.svg": "29c3",
	"./Form1.svg": "1420",
	"./Form2.svg": "6d0f",
	"./Form3.svg": "33f3",
	"./Form4.svg": "e1eb",
	"./Form5.svg": "0255",
	"./contact.svg": "be15",
	"./discord-logo.svg": "5321",
	"./gpt-vs-selfpetition-output.svg": "5086",
	"./selfpetitionusa-logo.svg": "82f7",
	"./shape2.svg": "30bc",
	"./shape3.svg": "7dd3",
	"./shape4.svg": "2970",
	"./testimonial-4.svg": "da37",
	"./testimonial-5.svg": "7528",
	"./vs-comparison.svg": "4ead",
	"./vs-gpt.svg": "0b86",
	"./vs-selfpetition.svg": "6f56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "14fd";